let jumpTextSelection = false;

export function setJumpTextSelection(jump) {
  jumpTextSelection = jump;
}

export function getJumpTextSelection() {
  return jumpTextSelection;
}
